import { NgModule } from '@angular/core';
import { FilterPipe } from './pipes/shared/filter-pipe/filter.pipe';
import { LanguagePipe } from './pipes/shared/language.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FilesComponentDuplicate } from './modules/shared/files/files.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatNativeDatetimeModule, MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AngularMaterialModule } from './material.module';
import { ErrorInterceptorService } from './services/error-interceptor/error-interceptor.service';
import { RequestInterceptorService } from './services/request-interceptor/request-interceptor.service';
import { DynamicConditionEval, FetchActiveStepsCount } from './pipes/shared/SafeFilePipe';
import { scrollToFixDirective } from './directive/on-scroll-to-fix.directive';
import { SuccessModalComponent } from './modules/shared/success-modal/success-modal.component';
import { LocalDatePipe, LocalDateTimePipe } from './pipes/shared/date/dateformat';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18/', '.json');
}

@NgModule({
  declarations: [
    FilterPipe,
    LanguagePipe,
    scrollToFixDirective,
    FilesComponentDuplicate,
    FetchActiveStepsCount,
    SuccessModalComponent,
    LocalDateTimePipe,
    LocalDatePipe,
    DynamicConditionEval,



  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularMaterialModule,
    AngularEditorModule,
    ImageCropperModule,
    PortalModule,
    MatIconModule,
    OverlayModule,
    MatNativeDatetimeModule,
    MatDatetimepickerModule,
    MatDialogModule,
    NgbModule,
    MatRadioModule,
    MatInputModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    FilterPipe,
    LanguagePipe,
    MatSelectModule,
    MatDialogModule,
    FilesComponentDuplicate,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularMaterialModule,
    AngularEditorModule,
    ImageCropperModule,
    PortalModule,
    MatIconModule,
    OverlayModule,
    MatNativeDatetimeModule,
    MatDatetimepickerModule,
    MatDialogModule,
    NgbModule,
    MatRadioModule,
    MatInputModule,
    FetchActiveStepsCount,
    scrollToFixDirective,
    SuccessModalComponent,
    LocalDateTimePipe,
    LocalDatePipe,
    DynamicConditionEval
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
  ]
})

export class SharedModule {

}
